import EventCollection from "nexia_mobile/models/event_collection";
import BaseModel from "nexia_mobile/models/base_model";
import Editable from "nexia_mobile/models/mixins/editable";
import HasIcon from "nexia_mobile/models/mixins/has_icon";
import LocalSettings from "nexia_mobile/models/local_settings";
import Dispatch from "nexia_mobile/flux_like/dispatch";

class Automation extends BaseModel {
  nestedCollections() {
    return {
      events: {
        collection: EventCollection,
      },
    };
  }

  initialize() {
    super.initialize();
    this._connectShownOnDashboardAttribute();
  }

  toJSON() {
    return {
      name: this.get("name"),
      // TODO: shouldnt have to stringify 'enabled', but endpoint is only
      // working with string values for false
      enabled: JSON.stringify(this.get("enabled")),
    };
  }

  activate() {
    return this.postCommand("activate").then(() => {
      Dispatch("DEMO_MODE_EVENT", this, "Activated automation");
    });
  }
  parseLinksFilterEvents(links) {
    let link = _.first(links);
    if (link) {
      this.set("filterEventsUrl", link.getHref());
    }
  }

  isNameEditable() {
    return true;
  }

  _connectShownOnDashboardAttribute() {
    if (LocalSettings.getAutomationShownOnDashboard(this._numericId())) {
      this.set("shownOnDashboard", true);
    } else {
      this.set("shownOnDashboard", false);
    }

    this.on("change:shownOnDashboard", () => {
      let bool = Boolean(this.get("shownOnDashboard"));
      LocalSettings.setAutomationShownOnDashboard(this._numericId(), bool);
    });
  }

  _numericId() {
    let url = this.get("id");
    let urlParts = url.split("/");
    let lastPart = urlParts[urlParts.length - 1];
    return Number(lastPart);
  }
}

_.extend(Automation.prototype, Editable);
_.extend(Automation.prototype, HasIcon);
export default Automation;



// WEBPACK FOOTER //
// ./src/models/automation.js